import { REFLECTION_CARDS_FEATURE_FLAG } from 'featureFlags/config';
import { useParticipantsFeatureFlag } from 'featureFlags/hooks';

import {
  JOURNAL_NOTE_TYPES,
  JOURNAL_SPRINT_FILTERS,
  JournalFilterButton,
  useJournalFilterContext,
} from 'features/journal';

export const JournalFilterSessionPrep = () => {
  const { queryParams, onQueryParamsChange, resetQueryParams } =
    useJournalFilterContext();
  const isReflectionCardsEnabled = useParticipantsFeatureFlag(
    REFLECTION_CARDS_FEATURE_FLAG
  );
  if (!isReflectionCardsEnabled) {
    return null;
  }

  const isActive = queryParams.noteTypes?.includes(
    JOURNAL_NOTE_TYPES.REFLECTION_QUESTION
  );

  const handleSessionPrepFilterChange = () => {
    if (isActive) {
      resetQueryParams();
      return;
    }

    onQueryParamsChange({
      noteTypes: [JOURNAL_NOTE_TYPES.REFLECTION_QUESTION],
      sprintIds: [JOURNAL_SPRINT_FILTERS.ALL],
    });
  };

  return (
    <JournalFilterButton
      isActive={!!isActive}
      onClick={handleSessionPrepFilterChange}
      dataTestid="journal-sidebar-filter-session-prep"
    >
      Session prep
    </JournalFilterButton>
  );
};
